import { render, staticRenderFns } from "./CopyHomework.vue?vue&type=template&id=3e6ddce3&"
import script from "./CopyHomework.vue?vue&type=script&lang=js&"
export * from "./CopyHomework.vue?vue&type=script&lang=js&"
import style0 from "./CopyHomework.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports